import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from '@/libs/plugins/logger';
import createPersistedState from 'vuex-persistedstate';

import ui from './modules/ui';
import iOrderCore from './modules/iOrderCore';
import iOrderCheckout from './modules/iOrderCheckout';
import root from './root';

Vue.use(Vuex);

const plugins = [createPersistedState({
  key: 'COATv1',
  paths: [
    'ui',
    'iOrderCore',
    'iOrderCheckout',
    'site',
    'table'
  ]
})]
const debug = process.env.NODE_ENV !== 'production';
debug ? plugins.push(createLogger()) : null;


export default new Vuex.Store({
  ...root,
  plugins,
  strict: debug,
  modules: {
    ui,
    iOrderCore,
    iOrderCheckout
  },
});
